export type LogoutSource = 'logout' | 'accountDeletion'

export const createLogoutUrl = (origin: string, source: LogoutSource) => {
    return `${origin}/signin?source=${source}`
}
